import { ConditionValue } from '@makyoapp/makyo-common'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'
import { useAppBrandKitContext } from '@/context/AppBrandKitContext'
import { useBuilderColorSchemeV2 } from '@/hooks/__project__/useBuilderColorSchemeV2'
import { useCheckVisibilityV2 } from '@/hooks/__project__/useCheckVisibilityV2'
import { ComponentSettingKey } from '@/shared/builder'
import { ParentComponentProps } from '@/shared/builder/types'

import { CompSectionWrapperCore } from '../core/section/wrapper'
import { CompSection } from './CompSection'

/**
 * CompSectionWrapper
 */
function CompSectionWrapper({ children }: Readonly<ParentComponentProps>) {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // form
  const { formState } = useCompFormContext()

  // styles
  const colorSchemeIdx = compContext.settings[ComponentSettingKey.SectionDesignBgScheme] || '0'

  // brandkit
  const [themeState] = useBuilderColorSchemeV2()
  const { themes, currentTheme } = useAppBrandKitContext()
  const currentBrandKitTheme = themes[Number(colorSchemeIdx)] ?? currentTheme
  const brandkitProps = { themes, currentTheme: currentBrandKitTheme, mode: themeState.current }

  // visibility
  const { checkVisibility } = useCheckVisibilityV2()

  function onCheckVisibility(visibility: ConditionValue) {
    return checkVisibility({
      visibility,
      formState,
      layerTableId: compContext.detailTableId,
      layerRowIndex: compContext.detailRowIndex,
    })
  }

  return (
    <CompSectionWrapperCore core={infosProps} brandkit={brandkitProps}>
      {(wrapperProps) => (
        <CompSection {...wrapperProps} onCheckVisibility={onCheckVisibility}>
          {children({})}
        </CompSection>
      )}
    </CompSectionWrapperCore>
  )
}

export default CompSectionWrapper
